import React, {useState} from "react";
import CloseButton from "./../icons/CloseButton";
import emailjs from 'emailjs-com';
import { Modal } from "../Model";
import { GlobalStyle } from "../../globalStyles";
import {
  BodyNoScroll,
  RegisterYourInterestWrapper,
  RegisterYourInterestScrim,
  RegisterYourInterestFormDiv,
} from "./elements";

const RegisterYourInterestForm = ({ closeForm, isJoin, venueName }) => {
    const [showModal, SetShowModal] = useState(false)

  const endPoint = isJoin
    ? "https://go.alserkalavenue.ae/l/776773/2021-03-30/dtlr6l"
    : "https://go.alserkalavenue.ae/l/776773/2021-03-25/dsqm5v";

  const handleSubmit = async (event) => {
    // console.log(event.target);
    event.preventDefault();
    var venueTemplate = event.target.unitSize;
    if(venueTemplate === undefined){  
      emailjs.sendForm('service_b63obcc', 'template_4f4gt6t', event.target, '1oiFBKwf2u2uXZh0F')
          .then((result) => {            
          }, (error) => {
              console.log(error.text);
          });
          } else {           
          emailjs.sendForm('service_b63obcc', 'template_u21s9jj', event.target, '1oiFBKwf2u2uXZh0F')
          .then((result) => {
            
          }, (error) => {
              console.log(error.text);
          });
            }
    // extract form data
    const formdata = new FormData(event.target);

    // convert FormData to json object
    // SOURCE: https://stackoverflow.com/a/46774073
    const json = {};
    formdata.forEach(function (value, prop) {
      json[prop] = value;
    });

    // convert json to urlencoded query string
    // SOURCE: https://stackoverflow.com/a/37562814 (comments)
    const formBody = Object.keys(json)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(json[key])
      )
      .join("&");
      event.target.reset();
    // POST the request to Staticman's API endpoint
    const response = await fetch(endPoint, {
      mode: "no-cors",
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formBody,
    })
      .then((response) => {
        // reset form
      //  console.log("success!", response);
       
        SetShowModal(prev => !prev)

       // closeForm(true);
      })
      .catch((error) => {
     
         //event.target.reset();
          closeForm(true);
      });
     
  };

  return (
    <RegisterYourInterestWrapper
      accentColor={isJoin ? "var(--red)" : "var(--purple)"}
    >
      <BodyNoScroll />
      <RegisterYourInterestScrim
        onClick={() => {
          closeForm(true);
        }}
      ></RegisterYourInterestScrim>
      <RegisterYourInterestFormDiv>
        <CloseButton
          color={isJoin ? "var(--red)" : "var(--purple)"}
          onClick={() => {
            closeForm(true);
          }}
        />
        <h1>{isJoin ? "Share your idea with us" : "Get in touch"}</h1>
        <form
          // action={endPoint}
          // method="post"
          onSubmit={handleSubmit}
        >
          <div>
            <label>
              First name
              <input type="text" name="firstName" required />
            </label>
            <label>
              Last name
              <input type="text" name="lastName" required />
            </label>
          </div>
          {isJoin ? null : (
          <label>
            Company name
            <input type="text" name="companyName" required />
          </label>
          )}
          <label>
            Email address
            <input type="email" name="email" required />
          </label>
            
            {isJoin ?  (
              <div>
              <label>
                Mobile number
                <input type="text" name="mobileNumber" required />
              </label>
            <label>
              Phone number
              <input type="text" name="phoneNumber" />
            </label>
            </div>
            ):
            <label>
              Mobile number
              <input type="text" name="mobileNumber" required />
            </label>
            }
            {isJoin ?null:(
          <label>
            {isJoin ? "Move-in date" : "Event start date"}
            <input
              type="text"
              name={isJoin ? "moveInDate" : "eventstartDate"}
              required
            />
          </label>)}
          {isJoin ? null : (
            <label>
              {isJoin ? "Rental budget" : "Event end date"}
              <input
                type="text"
                name={isJoin ? "rentalBudget" : "eventDates"}
                required
              />
            </label>
          )}

          <div className="textarea">
            <label>
              Tell us about your {isJoin ? "idea":"event"}
              <textarea name="tellus"  placeholder={isJoin ? "" : "We'd love to know more! Tell us all about your event, eg number of people, event type, is it open to the public or private?"}/>
            </label>
          </div>
          {isJoin ?(
          <label>
            Company name
            <input type="text" name="companyName" required />
          </label>
          ):null}
          <label>
             {isJoin ? "Required size of unit" : "Preferred Venue"}
            <input
              type="text"
              placeholder={isJoin ?"Enter size in sqft":"Do you have a preferred venue in mind? If so, please share it with us"}
              name={isJoin ? "unitSize" : "venueSize"}
              required
            />
          </label>
          {isJoin ?(
          <label>
            {isJoin ? "Move-in date" : "Event date(s)"}
            <input
              type="text"
              name={isJoin ? "moveInDate" : "eventDates"}
              required
            />
          </label>):null}
          {/* {isJoin ? null : (
            <label>
              {isJoin ? "Rental budget" : "Venue budget"}
              <input
                type="text"
                name={isJoin ? "rentalBudget" : "venueBudget"}
                required
              />
            </label>
          )} */}

          
          
          {venueName ? (
            <input type="hidden" value={venueName} name="venueName" />
          ) : null}
          <input type="submit" value={isJoin ? "Submit" : "Submit"} />
          <Modal showModal={showModal} SetShowModal={SetShowModal} close={() => {
          SetShowModal(false);
        }}/>  
        <GlobalStyle />
        </form>
      </RegisterYourInterestFormDiv>
    </RegisterYourInterestWrapper>
  );
};

export default RegisterYourInterestForm;
